import { useState } from 'react'
import { GalleryImageItem } from '@/components/commons/gallery-image-item'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { Edit02Icon, Expand01Icon, Image01Icon } from '@/components/ui/icons'
import {
	OpsVettingGalleryItemsContainer,
	OpsVettingNoCoverPhotoContainer
} from '@/features/ops-vetting/components/ops-vetting-atoms'
import { ServiceVettingCriteriaChoosePhotoModal } from '@/features/service-vetting/components/service-vetting-criteria-choose-photo-modal'
import { useUpdateIsCoverGalleryImg } from '@/features/service-vetting/query/use-update-is-cover-gallery-img.ts'
import type { ServiceGalleryImage } from '@/features/service-vetting/types.ts'
import { useTranslation } from '@/translations/i18n'

export const ServiceVettingCriteriaCoverPhoto = ({
	coverPhoto,
	hideAction,
	serviceId,
	galleryId,
	onClickExpand
}: {
	coverPhoto?: ServiceGalleryImage
	hideAction: boolean
	galleryId: number
	serviceId: number
	onClickExpand?: (image: ServiceGalleryImage) => void
}) => {
	const { t } = useTranslation()
	const [showModal, setShowModal] = useState(false)
	const updateIsCoverGalleryImg = useUpdateIsCoverGalleryImg(
		{ galleryId, serviceId },
		{ onSuccess: () => setShowModal(false) }
	)

	const onConfirm = (id: number) => {
		updateIsCoverGalleryImg.mutate({ is_cover: true, imgId: id })
	}
	return (
		<>
			<OpsVettingGalleryItemsContainer direction='column' gap={4}>
				{coverPhoto ? (
					<GalleryImageItem
						bottomRightSlot={
							!hideAction && (
								<ButtonLegacy
									className='show-on-hover'
									onClick={() => onClickExpand?.(coverPhoto)}
									shape='square'
									type='button'
									variant='secondary'
								>
									<Expand01Icon />
								</ButtonLegacy>
							)
						}
						src={coverPhoto.thumbnails?.xs || coverPhoto.url}
						topRightSlot={
							!hideAction && (
								<ButtonLegacy
									onClick={() => {
										setShowModal(true)
									}}
									shape='square'
									type='button'
									variant={'secondary'}
								>
									<Edit02Icon />
								</ButtonLegacy>
							)
						}
					/>
				) : (
					<OpsVettingNoCoverPhotoContainer
						align={'center'}
						direction={'column'}
						gap={2}
						justify={'center'}
					>
						<Image01Icon size={32} />
						<div className='flex flex-col items-center'>
							<h4>
								{t(
									'vetting:criteria.service.gallery.no_cover_photo'
								)}
							</h4>
							{!hideAction && (
								<ButtonLegacy
									onClick={() => setShowModal(true)}
									size={'sm'}
									type='button'
									variant={'tertiary'}
								>
									{t('common:choose_a_photo')}
								</ButtonLegacy>
							)}
						</div>
					</OpsVettingNoCoverPhotoContainer>
				)}
			</OpsVettingGalleryItemsContainer>
			{showModal && (
				<ServiceVettingCriteriaChoosePhotoModal
					currentSelectedImageId={coverPhoto?.id}
					galleryId={galleryId}
					isPending={updateIsCoverGalleryImg.isPending}
					onClose={() => setShowModal(false)}
					onConfirm={onConfirm}
					serviceId={serviceId}
					title={t('vetting:criteria.service.gallery.cover_photo')}
				/>
			)}
		</>
	)
}
